<ng-container *ngIf="hasError">
    <div class="login-error" [innerHTML]="errorMessage"></div>
</ng-container>

<ng-container #fieldComponent></ng-container>

<sl-button class="button btn--secondary" type="button" (click)="onRegister()">Register</sl-button>

<sl-dialog [open]="modalOpen" [noHeader]="true" (sl-hide)="onClose()">
    <span>Please create a password</span>
    <sl-divider></sl-divider>
    <sl-input
        class="input" 
        label="Password" 
        type="password" 
        placeholder="Insert your password"
        [passwordToggle]="true"
        (sl-input)="onPasswordChange($event)">
    </sl-input>
    <sl-input 
        class="input" 
        label="Confirmation Password" 
        type="password"
        placeholder="Insert your confirmation password" 
        [passwordToggle]="true"
        (sl-input)="onConfirmPasswordChange($event)">
    </sl-input>
    <p *ngIf="passwordErrorMessage" class="error-message">{{ passwordErrorMessage }}</p>
    <sl-divider></sl-divider>
    <div class="button-wrapper">
        <sl-button class="btn--secondary" (click)="onClose()">Cancel</sl-button>
        <sl-button class="button__cancel btn--primary" (click)="onSubmit()" [disabled]="isCreateDisabled">Create Profile</sl-button>
    </div>
</sl-dialog>